<template>
  <div class="home">
    <!-- <script2 src="../../public/assets/assets/js/jquery-2.2.4.js"></script2> -->
    <!-- <script2 src="/assets/assets/js/common2.js"></script2> -->
    <!-- <script2 src="/assets/assets/js/common_page_home2.js"></script2> -->
    <!-- <script2 src="/assets/js/cbpHorizontalMenu.js"></script2> -->
    <scmenueng></scmenueng>
    <div class="main-wrapper">
      <main role="main">
        <div class="main-contents">
          <div id="kv" class="kv js-intro js-play">
            <div id="kv-inner" class="kv-inner">
              <div class="kv-intro">
                <div class="kv-intro__body">
                  <span class="kv-intro__logo"><img src="/assets/assets/img/home/SS-logo400x400.png" alt="Scandinavia Service"></span>
                  <p class="kv-intro__txt text_serif_intro">Born from the field of cosmetic skin care<br>Scandinavian Beauty Devices and Skin Care</p>
                </div>
              </div>
              <div class="slideshow-images">
                <div class="viewport">
                  <ul class="slideshow" style="display: none;">

                    <!-- モニター募集 -->
                    <li class="slideshow-cell  pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl" v-bind:class="{ margintop300px: !largescreen }"><img src="/assets/assets/img/home/monitordaiboshu-eng.png" alt="Recruiting Monitors" class="img"></h2>
                          <p class="kv__btn"><router-link to="" class="btn">Monitor registration form</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s0nt.webp" alt="POWERLITE treatment" class="img"></p>
                    </li>

                    <li class="slideshow-cell  pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl" style="margin-top: -300px;"><img src="/assets/assets/img/home/kv_brandstory_title2-eng.png" alt="Gentle to the skin Reaching the Bulge Light epilation Machine" class="img"></h2>
                          <p v-if="largescreen===true" class="kv__txt text-serif-100">
                            "POWERLITE" was the first light hair removal device sold in Japan.
                            This machine boasts a history of over 25 years.
                            Due to its effectiveness and safety, it has been introduced in many salons.</p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">
                            The first light hair removal device sold in Japan
                            "POWERLITE" boasts a history of over 20 years
                            This machine is highly effective and safe.
                            It has been introduced in many salons.</p>
                          <img v-if="largescreen===true" src="/assets/img/400NEpro35pro55.webp" alt="パワーライトシリーズ" id="pl400nepro35pro55_img" class="img">
                          <img v-if="largescreen===false" src="/assets/img/400NEpro35pro55.webp" alt="パワーライトシリーズ" id="pl400nepro35pro55_img" class="img">
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s1nt.jpg" alt="女性モデル" class="img"></p>
                    </li>

                    <!-- <li class="slideshow-cell color--wt pos--L"> -->
                    <li class="slideshow-cell pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl" v-bind:class="{ margintop300px: !largescreen }"><img src="/assets/assets/img/home/kv_skinpeel_title2-eng.png" alt="No technique required Highly effective results Slimming Machine" class="img"></h2>
                          <p v-if="largescreen===true" class="kv__txt text-serif-100">
                            We offer machines such as shock wave & cellumelt, which has a constant stream of repeat customers, and machines that can be used while still wearing clothes,
                            We will provide you with results that will satisfy you.
                          </p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">
                            Repeat customers are always coming back for Shockwave & Cellumelt and
                            We offer machines that allow treatment while remaining fully clothed.
                            Even if you don't have any special skills,
                            we can provide you with satisfying results.
                          </p>
                          <p class="kv__btn"><router-link to="/en/products" class="btn">To products page</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s2nt.jpg" alt="女性モデル" class="img"></p>
                    </li>

                    <li class="slideshow-cell pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl" v-bind:class="{ margintop300px: !largescreen }"><img src="/assets/assets/img/home/kv_takamilip_title2-eng.png" alt="Relaxation, Body Making and even Scalp care bioelectric current Machine" class="img"></h2>
                          <p  v-if="largescreen===true" class="kv__txt text-serif-100">
                            We mimic the bioelectric currents that humans possess and reproduce
                            them using our unique technology, called "Multi-Spectral Waves,"
                            which work on physical ailments and bring about improvement.
                          </p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">
                            We mimic the bioelectric currents that humans
                            possess and reproduce them using our unique
                            technology, called "Multi-Spectral Waves,"which
                            work on physical ailments and bring about improvement.
                          </p>
                          <p class="kv__btn"><router-link to="/en/products" class="btn">To Products</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s3nt.jpg" alt="背景画像" class="img"></p>
                    </li>

                    <li class="slideshow-cell pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl"><img src="/assets/assets/img/home/kv_lotion_title2-eng.png" alt="Beautiful skin and small face Realized with the latest technology Facial Machine" class="img"></h2>
                          <p v-if="largescreen===true"class="kv__txt text-serif-100">
                            The latest facial beauty machine that improves skin
                            quality such as blemishes and wrinkles, and addresses
                            aging symptoms such as sagging and swelling.
                          </p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">
                            The latest facial beauty machine that improves skin
                            quality such as blemishes and wrinkles, and addresses
                            aging symptoms such as sagging and swelling.
                          </p>
                          <p class="kv__btn"><router-link to="/en/products" class="btn">To products page</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s4nt.jpg" alt="女性モデル施術風景" class="img"></p>
                    </li>

                    <!-- <li class="slideshow-cell pos--B text--center"> -->
                    <li class="slideshow-cell pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <p v-if="largescreen===true" class="kv__txt text-serif-100">
                            The "SnowWhite" series is a skincare line made for salon
                            treatments that require high effectiveness. It includes a
                            variety of unique items, from face washes to beauty serums.
                          </p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">
                            The "SnowWhite" series is a skincare line
                            made for salon treatments that require high
                            effectiveness. It includes a variety of unique
                            items, from face washes to beauty serums.
                          </p>
                          <h2 class="kv__ttl"><img src="/assets/assets/img/home/kv_skincareline_title2-eng.png" alt="Cosmetics exclusively for salons, developed in collaboration with Swedish doctors" class="img"></h2>
                          <p class="kv__btn"><router-link to="/en/cosmetics" class="btn">List of Priducts</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s5nt.jpg" alt="female model" class="img"></p>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>

    <section class="horizontalmenu">
      <div class="container">
        <div class="main">
          <nav id="cbp-hrmenu" class="cbp-hrmenu">
            <ul>
              <li>
                <a href="#"> <img src="/assets/img/face.jpg" alt="FACE"> </a>
                <div class="cbp-hrsub">
                  <div class="cbp-hrsub-inner">
                    <div>
                      <ul>
                        <li><a href="/pro55eng.html">Powerlite Pro55</a></li>
                        <li><a href="/pro35eng.html">Powerlite Pro35</a></li>
                        <li><a href="/400neeng.html">Powerlite 400NE</a></li>
                      </ul>
                    </div>
                  </div><!-- /cbp-hrsub-inner -->
                </div><!-- /cbp-hrsub -->
              </li>
              <li>
                <a href="#"> <img src="/assets/img/body.jpg" alt="BODY体"></a>
                <div class="cbp-hrsub">
                  <div class="cbp-hrsub-inner">
                    <div>
                      <ul>
                        <li><a href="/pro55eng.html">Powerlite Pro55</a></li>
                        <li><a href="/en/drpro.html">Dr-PRO</a></li>
                        <li><a href="/en/magblade.html">MAGBLADE</a></li>
                        <!-- <li><a href="#">Evolution Slim</a></li> -->
                       <!--  <li><router-link to="/drpro">Dr-PRO</router-link> </li>-->
                      </ul>
                    </div>
                  </div><!-- /cbp-hrsub-inner -->
                </div><!-- /cbp-hrsub -->
              </li>
              <li>
                <a href="#"> <img src="/assets/img/hair.jpg" alt="HAIR"></a>
                <div class="cbp-hrsub">
                  <div class="cbp-hrsub-inner">
                    <div>
                      <ul>
                        <li><router-link to="/en/hm">Hair Medic</router-link></li>
                        <!-- <li><router-link to="/drpro">Dr-PRO</router-link></li> -->
                        <!-- <li><router-link to="/drprohs">Dr-PRO HS</router-link></li> -->
                      </ul>
                    </div>
                  </div><!-- /cbp-hrsub-inner -->
                </div><!-- /cbp-hrsub -->
              </li>
              <li>
                <a href="#"> <img src="/assets/img/cosme.jpg" alt="Cosmetics"></a>
                <div class="cbp-hrsub">
                  <div class="cbp-hrsub-inner">
                    <div>
                      <ul>
                        <li><router-link to="/en/cosmetics">SnowWhite Series</router-link></li>
                        <li><router-link to="/en/plcosmetics">Powerlite Series</router-link></li>
                        <li><router-link to="/en/accosmetics">Anti Cellulite Series</router-link></li>
                        <li><router-link to="/en/hmcosmetics">HAIRMEDIC Series</router-link></li>
                      </ul>
                    </div>
                  </div><!-- /cbp-hrsub-inner -->
                </div><!-- /cbp-hrsub -->
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </section>
    <div class="page_content">
      <div class="box0">
        <div class="box1"><router-link to="/en/products">Products</router-link></div>
        <div class="box1"><router-link to="/en/support">Suppport</router-link></div>
      </div>

      <!-- <br>
           <div class="cosmetics_banner cosme" @click.stop="gotohomecare_drpro">
           <a><img src="/assets/img/homecareseries_top_DRPRO-960x329.png" alt="感動の最新美容テクノロジーDr-PROホームケアシリーズ"></a>
           </div>       -->

      <br>
      <div class="cosmetics_banner cosme">
        <router-link to="/en/cosmetics"><img src="/assets/img/SW_top-eng.png" alt="うるおいの力で肌本来の美しさを呼び覚ます年齢に左右されない輝く肌へSnowWhiteスノーホワイト化粧品"></router-link>
      </div>

      <br>
      <hr>
      <br>
      <h2 class="news-media-heading">News</h2>

      <dl>

<dt>2026/02/16 </dt>
<router-link to="/en/newsbw2026fukuoka">
  <dd>Beautyworld Japan Fukuoka 2026 Exhibition Announcement</dd>
</router-link>

<dt>2025/12/26 </dt>
<router-link to="/en/news20251226">
  <dd>Year-end and New Year Holidays</dd>
</router-link>
           <!--
 <dt>2025/07/02 </dt>
        <router-link to="/en/news251020en"><dd>Exhibiting at Beauty World Japan 2025 Osaka</dd></router-link>
        <dt>2025/06/24 </dt>
         <router-link to="/en/news250714en"><dd>Exhibiting at Beauty World Japan 2025 nagoya</dd></router-link>
         <dt>2025/04/02 </dt>
        <router-link to="/news250401"><dd>Exhibiting at Beauty World Japan 2025 Tokyo</dd></router-link>
        <dt>2025/02/19 </dt>
        <a href="/en/products#beauty_jet_jr"><dd>Announcing SnowWhite BEAUTY JET Jr.</dd></a>
        <dt>2025/01/09 </dt>
        <router-link to="/newsBWF2025"><dd>Exhibiting at Beauty World Japan 2025 Fukuoka</dd></router-link>
        <dt>2024/07/24 </dt>
        <router-link to="/news240724bwn"><dd>Exhibiting at Beauty World JAPAN 2024 Nagoya！</dd></router-link>
        <dt>2023/09/27 </dt>
        <router-link to="/news231018"><dd>Exhibiting at Leisure & Service Industry Exhibition</dd></router-link>
        <dt>2023/09/27 </dt>
        <router-link to="/news231005"><dd>Exhibiting at Femtech Tokyo</dd></router-link>
        <dt>2023/07/12 </dt>
        <router-link to="/news230712bwn"><dd>Exhibiting at Beauty World Japan 2023 Nagoya</dd></router-link>
        <dt>2023/05/01 </dt>
        <router-link to="/news230501"><dd>Exhibiting at Beauty World Japan 2023</dd></router-link>
        <dt>2023/01/25 </dt>
        <router-link to="/news230125bwf"><dd>Exhibiting at Beauty World Japan 2023 Fukuoka</dd></router-link>
        <!--
        <dt>2023/01/25 </dt>
        <router-link to="/news230125gs"><dd>第95回 東京インターナショナル ギフト・ショー 春2023に出展のお知らせ</dd></router-link>
        <dt>2022/05/11 </dt>
        <router-link to="/news220511"><dd>ビューティーワールド ジャパン出展のお知らせ</dd></router-link>
        <dt>2022/02/02 </dt>
        <router-link to="/news220202"><dd>ビューティーワールドジャパン福岡出展のお知らせ</dd></router-link>
        <dt>2022/01/11 </dt>
        <router-link to="/news220111"><dd>【重要】弊社製品の転売・保証について</dd></router-link>
        <dt>2021/10/04 </dt>
        <router-link to="/news211004"><dd>10/13(水)東京ギフトショー×NEXT LEADER　出展のおしらせ</dd></router-link>
        <dt>2021/05/24 </dt>
        <router-link to="/news210524"><dd>【名古屋】6/17(木)〜19(土)スポーツ・ウェルネス産業総合展に出展します</dd></router-link>
             <dt>2020/12/17 </dt>
             <dd>冬期休暇は2020年12月26日(土)〜1月3日(日)となり、通常営業は1月4日(月)からとなります。</dd>
             <dt>2020/05/14 </dt>
             <dd>■重要なお知らせ■<br>
             新型コロナウィルス感染拡大の状況を考慮し、弊社では4月21日(火)から5月末日(日)まで勤務人数を縮小しての営業となります。 それに伴い、エンジニアの土日祝日のスタンバイも休止とさせていただきます。修理等の対応は6月1日（月）以降となりますのでご協力お願いいたします。
             電話でのお問い合わせは受け付けておりますが、返答までにお時間を頂戴する場合がございますので、予めご了承ください。
             なお、商品のご注文に関しては通常通り発送が可能ですが、大量のご注文等はお時間と頂戴する可能性がございます。
             また、当日出荷の締め切り時間を平日15時から14時に変更とさせていただきます。
             ご不便をお掛けし申し訳ございませんが、ご理解の程よろしくお願いいたします。</dd>
             <dt>2019/07/02 </dt>
             <router-link to="/sugaringseminar"><dd>SUN KISSED Skin セミナー開始！</dd></router-link>
             <dt>2019/05/23 </dt>
             <dt>2019/06/07 </dt>
             <router-link to="/BeautySpecialistAward"><dd>Beauty Specialist Award 開催決定！</dd></router-link>
             <dt>2019/05/23 </dt>
             <router-link to="/sugaring"><dd>「SUN KISSED Skin」シュガーリング脱毛新発売。</dd></router-link>
             <dt>2019/04/12 </dt>
             <router-link to="/bw2019"><dd>「ビューティーワールドジャパン2019」に出展いたします。</dd></router-link>
             <dt>2019/03/01 </dt>
             <dd>ランプキャンペーン</dd>
             <dt> </dt>
             <dt>2019/02/07 </dt>
             <a href="/assets/img/MISS-JAPAN-BEAUTY-kekka.jpg" target="_blank"><dd>MISS JAPAN BEAUTY コンテストグランプリ結果発表</dd></a>
             <dt>2018/12/29 </dt>
             <dd>冬期休暇は2018年12月29日(土)〜1月3日(木)となり、通常営業は1月4日(金)からとなります。</dd>
             <dt>2018/05/01 </dt>
             <dd>Miss Japan Beauty 開催</dd>
             <dt>2018/04/22 </dt>
             <dd>コスメキャンペーン</dd>
             <dt>2018/04/01 </dt>
             <dd>ランプキャンペーン</dd>
             <dt> </dt>
             <dd>Smart Dren DUAL</dd>
             <dt>2018/03/01 </dt>
             <dd>Scandinavia News Spring/Summer</dd>
        -->
      </dl>

      <br>
      <hr>
      <br>
      <h2 class="news-media-heading">Media Coverage</h2>
      <dl>
        <dt>2021/08/26 </dt>
        <a href="https://prtimes.jp/main/html/rd/p/000000004.000077721.html" target="_blank"><dd>A press release has been published about the new salon-exclusive color of "Dr-PRO Beauty Secret" to be released on September 1st</dd></a>
        <dt>2018/11/10 </dt>
        <a href="/assets/img/esthetic-wired.jpg" target="_blank"><dd>Esthetic Wired December Issue Best Item 2018 Award Winner</dd></a>
        <dt>2018/05/02 </dt>
        <dd>Esthetic Beauty May Issue</dd>
      </dl>


      <br>
      <hr>
      <br>
    </div>
    <footer2eng></footer2eng>
  </div>
</template>

<script>
 // import $ from "jquery";
 // @ is an alias to /src
 // var cbpHorizontalMenu = require('../../public/assets/js/cbpHorizontalMenu.min.js');
 export default {
   name: 'homeeng',
   props: {
     largescreen: {
       type: Boolean
     }
   },
   components: {
     scmenueng: () => import('../components/scMenuEng.vue'),
     footer2eng: () => import('../components/Footer2Eng.vue')
   },
   created() {
     /* document.addEventListener('DOMContentLoaded', function() {
      *   'use strict';
      *   console.log("DOM fully loaded and parsed");
      *   var $segment_1 = $('.slideshow');
      *   $segment_1.eq(0).show();
      * }, false); */


     /* document.addEventListener("DOMContentLoaded", function () {
      *   var body = document.getElementsByTagName("body")[0];
      *   var kv = document.getElementById("kv");
      *   kv.classList.add("js-intro");
      *   Keyvisual.intro.init();
      *   Keyvisual.parallax();
      *
      *   if (UA.browser === "msie" || UA.browser === "edge") {
	$("body").niceScroll({
	cursorcolor: "#b9b9b9",
	cursorwidth: "12px",
	cursorborderradius: "0px",
	cursorborder: "none",
	background: "#e6e6e6",
	autohidemode: false,
	railoffset: true,
	nativeparentscrolling: false,
	zindex: 101
	});
      *   }
      *
      * }, false); */
   },
   mounted() {
     Keyvisual.intro.init();
     Keyvisual.parallax();
     $('.slideshow').eq(0).show();

     document.addEventListener("DOMContentLoaded", function () {
       var body = document.getElementsByTagName("body")[0];
       var kv = document.getElementById("kv");
       kv.classList.add("js-intro");
       Keyvisual.intro.init();
       Keyvisual.parallax();

       if (UA.browser === "msie" || UA.browser === "edge") {
	 $("body").niceScroll({
	   cursorcolor: "#b9b9b9",
	   cursorwidth: "12px",
	   cursorborderradius: "0px",
	   cursorborder: "none",
	   background: "#e6e6e6",
	   autohidemode: false,
	   railoffset: true,
	   nativeparentscrolling: false,
	   zindex: 101
	 });
       }

     }, false);

     const plugin = document.createElement("script");
     plugin.setAttribute(
       "src",
       // added cbpHorizontalMenu.init(); at the end of cbpHorizontalMenu.js to make it work
       "/assets/js/cbpHorizontalMenu.js"
     );
     // plugin.async = true;
     plugin.async = false;
     document.head.appendChild(plugin);



     // Adding the file inline worked below

     // var cbpHorizontalMenu = (function() {

     //     var $listItems = $( '#cbp-hrmenu > ul > li' ),
     //         $menuItems = $listItems.children( 'a' ),
     //         $body = $( 'body' ),
     //         current = -1;

     //     function init() {
     //         $menuItems.on( 'click', open );
     //         $listItems.on( 'click', function( event ) { event.stopPropagation(); } );
     //     }

     //     function open( event ) {
     //         if( current !== -1 ) {
     //             $listItems.eq( current ).removeClass( 'cbp-hropen' );
     //         }
     //         var $item = $( event.currentTarget ).parent( 'li' ),
     //             idx = $item.index();
     //         if( current === idx ) {
     //             $item.removeClass( 'cbp-hropen' );
     //             current = -1;
     //         }
     //         else {
     //                 $item.addClass( 'cbp-hropen' );
     //             current = idx;
     //             $body.off( 'click' ).on( 'click', close );
     //         }
     //         return false;
     //     }
     //     function close( event ) {
     //         $listItems.eq( current ).removeClass( 'cbp-hropen' );
     //         current = -1;
     //     }
     //     return { init : init };
     // })();

     // cbpHorizontalMenu.init();

   },
   methods: {
     gotohomecare_drpro() {
       window.location.href = "https://scandinavianbeauty.jp/products/ドクタープロ-ビューティシークレット"
     },
   }
 };

</script>

<style lang="scss">
 /* slider */
 @import "../../public/assets/assets/css/base2.scss";
 @import "../../public/assets/assets/css/module2.scss";
 @import "../../public/assets/assets/css/page_home.scss";

 /* horizontalmenu */
 @import "../../public/assets/scss/component.scss";

 @import "../../public/assets/scss/style.scss";

 /* menu floats above slider in index.html only */
 #scmenueng {
   /*    padding-top: -200px; */
   /*    margin-top: -10px; */
   /*    z-index: 100; */
 }
 #scmenu {
   display: none;
 }
 #scmenueng .menu-section {
   position: absolute;
   /*    margin-top: 42px; */
   margin-left: -30px;
   z-index: 11;
 }
 @media (min-width: 601px) {
   .menu-section {
     /*      top: 53px; */
   }
 }
 @media (max-width: 600px) {
   .menu-section {
     top: 160px;
     /*      margin-top: 70px; */
     margin-left: 0;
   }
 }
 .menu-back {
   position: absolute;
   left: 0;
   height: 50px;
   width:100%;
   background-color: #fff;
   opacity: 0.9;
   z-index: 10;
   filter: drop-shadow(3px 3px 3px #ddd);
   border-top: 1px solid #ccc;
   border-bottom: 1px solid #ccc;
 }

 .text_serif_intro {
   font-family: serif;
 }

 /* for large screens */
 .kv__ttl img {
   width: 500px;
 }

 #pl400nepro35pro55_img {
   width: 300px;
   height: auto;
   position:absolute;
   top: 50%;
   left: 70%;
 }
 .margintop300px {
   margin-top: -300px;
 }
 /* ----------- iPhone 6+, 7+ and 8+ ----------- */
 @media (max-width: 414px) {
   .text_serif_intro {
     font-family: serif;
     letter-spacing: -2px;
   }
   .kv-intro__body {
     width: 400px;
   }
   .kv__ttl img {
     width: 390px;
   }
   .kv-intro {
     top: -60px;
   }
   .kv__cell-body {
     width:400px;
     #slider-text-smallscreen {
       letter-spacing: 0px;
     }
     #pl400nepro35pro55_img {
       width: 200px;
       height: auto;
       position:absolute;
       top: 45%;
       left: 20%;
     }
   }
   .menu-back {
     display: none;
   }
 }

 /* ----------- iPhone 6, 6S, 7, 8 and X----------- */
 @media (max-width: 375px) {
   .text_serif_intro {
     font-family: serif;
     letter-spacing: normal;
   }
   .kv-intro__body {
     width: 360px;
   }
   .kv__ttl img {
     width: 360px;
   }
   .kv-intro {
     top: -70px;
   }
   .kv__cell-body {
     width:370px;
     #slider-text-smallscreen {
       font-size: 1.8rem;
       letter-spacing: 0px;
     }
   }
 }

 /* ----------- iPhone 4, 4S, 5, 5S, 5C, 5SE and others with 320px----------- */
 @media (max-width: 320px) {
   .text_serif_intro {
     font-family: serif;
     font-size: 1.2em;
     letter-spacing: -2px;
   }
   .kv-intro__body {
     /* page_home.css line 60 */
     width: 300px;
   }
   .kv__ttl img {
     width: 300px;
   }
   .kv-intro {
     top: -50px;
   }
   .kv__cell-body {
     width:320px;
     #slider-text-smallscreen {
       font-size: 1.4rem;
       letter-spacing: 0px;
     }
     #pl400nepro35pro55_img {
       width: 150px;
       height: auto;
       position:absolute;
       top: 40%;
       left: 20%;
     }
   }
 }
</style>

<style lang="scss" scoped>
 .cosme {
   margin-top: 10px;
   height: 332px;
   /* border: 1px solid #2f609a; */
 }
 .box0 {
   display: flex;
   justify-content: space-between;
 }
 .box1 {
   color: #444;
   /* opacity: 0.5; */
   width: 48%;
   /* margin: 10px; */
   height: 70px;
   border: 1px solid #888;
   display: flex;
   justify-content: center;
   align-items: center;
 }
 .box1 a {
   text-decoration: none;
   display: flex;
   justify-content: center;
   align-items: center;
   /* background: #666; */
   width: 100%;
   height: 100%;
   text-align: center;
 }
 .box1:hover, .cosmetics_banner:hover {
   opacity: 1.0;
   color: #2f609a;
   background: #fff;
   border: 1px solid #2f609a;
   filter: drop-shadow(3px 3px 3px rgba(0,0,0,0.2));
   /* transition: color .55s ease-in-out; */
 }
 dl {
   /* border: 3px double #ccc; */
   padding: 10px;
   font-size: 0.9em;
 }
 dt {
   float: left;
   clear: left;
   width: 40px;
   text-align: right;
   font-weight: bold;
   color: #444;
 }
 dt::after {
   content: " ";
 }
 dd {
   margin: 0 0 0 130px;
   padding: 0 0 0.5em 0;
 }
 .news-media-heading {
   color: #2f609a;
 }
 @media (max-width: 600px) {
   .box0 {
     flex-direction: column;
   }
   .box1 {
     margin-top: 10px;
     width: 100%
   }
   .cosme {
     width: 100%;

     /* deal with extra space at bottom */
     /* img is 960 x 330, 330 / 960 = 0.34375, delete extra 3px */
     height: calc(100vw * 0.34375 - 3px);
   }
   .cosme img {
     width: 100%;
   }
 }

</style>
